import { ShippingProviderType } from '@/infrastructure/OMSClient';

export const SHIPPING_PROVIDER_LABELS: Readonly<Record<ShippingProviderType, string>> = {
  [ShippingProviderType.DELEO]: 'DELEO',
  [ShippingProviderType.FEDEX]: 'FEDEX',
  [ShippingProviderType.PARXL]: 'PARXL',
  [ShippingProviderType.YUN]: 'YUN EXPRESS',
};
